import { render, staticRenderFns } from "./DocumentDispatchLetter.vue?vue&type=template&id=d8ed3b34"
import script from "./DocumentDispatchLetter.vue?vue&type=script&lang=js"
export * from "./DocumentDispatchLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports